export default __webpack_public_path__ + "static/chad-ca1dc937f8a0b501cd9b6561594dcd0e.png";